// Centralized color configuration for theme-aware styling
// All components should import and use these instead of hardcoding hex values

export const getStatusConfig = (theme) => ({
  pending: { bg: "#ca5010", text: theme.text.primary },
  approved: { bg: "#107c10", text: theme.text.primary },
  executed: { bg: "#0078d4", text: theme.text.primary },
  inreview: { bg: "#8764b8", text: theme.text.primary },
  expired: { bg: "#a4262c", text: theme.text.primary },
  cancelled: { bg: "#6a6a6a", text: theme.text.primary },
  ontrack: { bg: "#107c10", text: theme.text.primary },
  atrisk: { bg: "#ca5010", text: theme.text.primary },
  overdue: { bg: "#a4262c", text: theme.text.primary },
});

export const getPriorityConfig = (theme) => ({
  high: { color: "#a4262c", label: "High" },
  medium: { color: "#ca5010", label: "Medium" },
  low: { color: "#107c10", label: "Low" },
  critical: { color: "#8764b8", label: "Critical" },
});

export const getEntityColors = (theme) => ({
  "Lekela": "#0078d4",
  "TFM": "#107c10",
  "O&G": "#ca5010",
  "FS": "#8764b8",
  "Other": theme.text.secondary,
});

export const getChartColors = (theme) => ({
  primary: "#c9a84c",
  secondary: theme.text.secondary,
  accent: "#0078d4",
  success: "#107c10",
  warning: "#ca5010",
  error: "#a4262c",
  grid: theme.isDark ? "#1e3054" : "#e4ddd4",
  text: theme.text.secondary,
});

export const getUrgencyColor = (days) => {
  if (days <= 7) return "#a4262c";
  if (days <= 14) return "#ca5010";
  if (days <= 30) return "#ffc107";
  return "#107c10";
};

export const getThemeAwareColor = (colorName, theme) => {
  const colorMap = {
    // Gold accents
    gold: "#c9a84c",
    goldLight: "#d4b560",
    goldDim: "#8a6e2f",

    // Backgrounds
    bgPrimary: theme.bg.primary,
    bgSecondary: theme.bg.secondary,
    bgTertiary: theme.bg.tertiary,

    // Text
    textPrimary: theme.text.primary,
    textSecondary: theme.text.secondary,
    textTertiary: theme.text.tertiary,

    // Borders
    border: theme.border,

    // Status colors (universal - not theme-dependent)
    statusPending: "#ca5010",
    statusApproved: "#107c10",
    statusExecuted: "#0078d4",
    statusInReview: "#8764b8",
    statusExpired: "#a4262c",
    statusCancelled: "#6a6a6a",
  };

  return colorMap[colorName] || colorName;
};
